import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "selected_weather_id"

export default class extends Controller {
  static targets = ["select", "hidden"]

  connect() {
    if (navigator.onLine) {
      this.saveServerValue()
    } else {
      this.restoreFromStorage()
    }
  }

  sync() {
    const value = this.selectTarget.value
    const label = this.selectTarget.options[this.selectTarget.selectedIndex]?.text

    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = value
    }

    if (value) {
      localStorage.setItem(STORAGE_KEY, value)
      localStorage.setItem(`weather_label_${value}`, label)
    } else {
      localStorage.removeItem(STORAGE_KEY)
    }
  }

  // Online: save value server to localStorage
  saveServerValue() {
    if (!this.hasSelectTarget) return

    const serverValue = this.selectTarget.value
    if (!serverValue) return

    // Sace value and label from server
    const label = this.selectTarget.options[this.selectTarget.selectedIndex]?.text
    localStorage.setItem(STORAGE_KEY, serverValue)
    if (label) localStorage.setItem(`weather_label_${serverValue}`, label)

    // Sync to hidden field
    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = serverValue
    }
  }

  // Offline: restore from localStorage
  restoreFromStorage() {
    if (!this.hasSelectTarget) return

    const saved = localStorage.getItem(STORAGE_KEY)
    if (!saved) return

    this.selectTarget.value = saved

    if (this.selectTarget.value !== saved) {
      this.injectOfflineOption(saved)
    }

    if (this.hasHiddenTarget) {
      this.hiddenTarget.value = saved
    }
  }

  // Inject option
  injectOfflineOption(weatherId) {
    const label  = localStorage.getItem(`weather_label_${weatherId}`) || `天気 (ID: ${weatherId})`
    const option = document.createElement("option")

    option.value            = weatherId
    option.textContent      = label
    option.dataset.offline  = "true"

    this.selectTarget.appendChild(option)
    this.selectTarget.value = weatherId
  }
}